import moment from "moment";
import React from "react";
import { SuccessBtn, ErrorBtn } from "../../Tables/TableButtons";

export const auditTrailColumns = [
  {
    Header: "User",
    accessor: "full_name",
    Cell: ({ row }) => (
      <div className="table-flex">
        <span style={{ "padding-right": "10px" }}>
          {row.original.first_name} {row.original.last_name}
        </span>
      </div>
    ),
  },

  {
    Header: "Activities",
    accessor: "action",
    Cell: ({ row }) => (
      <div className="table-flex">
        <span style={{ "padding-right": "10px" }}>{row.original.action}</span>
      </div>
    ),
  },
  {
    Header: "Date",
    accessor: "date",
    Cell: ({ row }) => (
      <div className="table-flex">
        <span> {moment(row.original.created_at).format("ll")}</span>
      </div>
    ),
  },
  {
    Header: "",
    accessor: "time",
    Cell: ({ row }) => (
      <div className="table-flex">
        {moment(row.original.created_at).format("LT")}
      </div>
    ),
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ row }) =>
      row.original.status === "success" ? (
        <SuccessBtn text={"Successful"} />
      ) : row.original.status === "failed" ? (
        <ErrorBtn text={"Failed"} />
      ) : (
        "Nil"
      ),
  },
];
